module.exports = {
	"trackingID": "GTM-NK2H74"
};


//////////////////
// WEBPACK FOOTER
// ./app/js/credentials/googleTagManager.credentials.json
// module id = 1411
// module chunks = 0